<h2 mat-dialog-title>Playlist data</h2>
<mat-dialog-content>
  <div class="playlist-form">
    <div class="cover">
      @if(image) {
        <img [src]="image" height="200" width="250" alt="playlist cover">
        <mat-icon class="del-cover-icon" (click)="image=''">delete_forever</mat-icon>
      } @else {
        <app-file-uploader (fileData)="attachFile($event)"></app-file-uploader>
      }

    </div>
    <div class="d-flex flex-col justify-center gap-20">
      <input matInput [(ngModel)]="name" class="admin-input-field"/>
<!--      <textarea matInput [(ngModel)]="description" class="admin-input-field" rows="5"></textarea>-->
    </div>
  </div>


</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()">Save</button>
</mat-dialog-actions>
